module.exports = __webpack_public_path__ + "img/pic-1-5.df96c91f.png";